const ServicesList = {
  // 'clinical-biochemistry': {
  //   service_name: 'Clinical Biochemistry',
  //   service_desecripiton: 'Clinical biochemistry (also known as clinical chemistry or chemical pathology) is the laboratory service absolutely essential for medical practice or branch of laboratory medicine in which chemical and biochemical methods are applied to the study of disease. The results of the biochemical investigations carried out in a clinical laboratory will help the clinicians to determine the diseases (diagnosis) and for follow-up of the treatment/recovery from the illness (prognosis). The results of biochemical tests may be of use in diagnosis and in the monitoring of treatment. Screening for disease or assessing the prognosis, to do research into the biochemical basis of disease.',
  //   services_offered: [
  //     {
  //       sub_service_name: 'Discretionary or on-off tests:',
  //       sub_service_description: 'Most common clinical biochemistry tests that are designed to answer specific questions, For example, Does the patient have increased blood urea/glucose concentration? Usually, these tests are useful to support the diagnosis.',
  //     },
  //     {
  //       sub_service_name: 'Dynamic function tests:',
  //       sub_service_description: `These tests are designed to measure the body's response to an external stimulus e.g., Oral glucose tolerance test (to assess glucose homeostasis): Bromosulphthfein test (to assess liver function).`,
  //     },
  //     {
  //       sub_service_name: 'Biochemical profiles:',
  //       sub_service_description: `These tests are based on the fact that more useful information on the patient's disease status can be obtained by analyzing more constituents rather than one e.g., plasma electrolytes (Na+, K+, Cl-, bicarbonate, urea); liver function tests (serum bilirubin, ALT, AST).`,
  //     },
  //   ]
  // },
  'histology-analysis': {
    service_name: 'Histology Analysis',
    service_desecripiton: 'Histology is the study of the microscopic structure of tissues. It involves examining cells and tissues under a microscope to understand their anatomy, function, and pathology. This field is crucial in diagnosing diseases, understanding biological processes, and advancing medical and scientific research. By analyzing tissue samples, histologists can provide insights into the mechanisms of diseases, the effects of treatments, and the intricate workings of various biological systems.',
    services_offered: [
      {
        sub_service_name: 'Tissue Processing:',
        sub_service_description: 'Tissue processing is the technique by which fixed tissues are made suitable for embedding within a supportive medium such as paraffin, and consists of three sequential steps: dehydration, clearing, and infiltration.',
      },
      {
        sub_service_name: 'Fixation',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Paraffin Embedding:',
            sub_category_description: 'For long term storage and detailed analysis.',
          },
          {
            sub_category_name: 'Frozen Sections:',
            sub_category_description: 'For immediate examination and specialized staining procedures.',
          }
        ]
      },
      {
        sub_service_name: 'Sectioning:',
        sub_service_description: 'Precision cutting of tissue samples to prepare them for microscopic examination.',
      },
      {
        sub_service_name: 'Staining:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Basic Stains:',
            sub_category_description: 'Hematoxylin and Eosin (H&E) for general tissue structure visualization.',
          },
          {
            sub_category_name: 'Advanced Stains',
            sub_category_description: '',
            super_sub_category: [
              {
                super_sub_category_name: `Masson's Trichrome`
              },
              {
                super_sub_category_name: `DAPI`
              },
              {
                super_sub_category_name: `Trypan Blue`
              },
              {
                super_sub_category_name: `Annexin`
              },
              {
                super_sub_category_name: `JC1`
              },
              {
                super_sub_category_name: `Sirius Red`
              },
              {
                super_sub_category_name: `Acridine Orange`
              },
              {
                super_sub_category_name: `PI, etc.`
              },
            ]
          }
        ]
      },
      {
        sub_service_name: 'Immunostaining:',
        sub_service_description: 'Detection and visualization of specific proteins and antigens within tissue samples using advanced immunostaining techniques.',
      },
      {
        sub_service_name: 'Histopathological Analysis:',
        sub_service_description: 'Detailed examination of a wide range of samples including:',
        subcategory: [
          {
            sub_category_name: 'Human medical specimens',
          },
          {
            sub_category_name: 'Dental tissues (Teeth-bone)',
          },
          {
            sub_category_name: 'Plant (all tissues)',
          },
          {
            sub_category_name: 'Animal tissues (Mice, Rat, Rabbit & other animal tissue)',
          },
        ]
      },
      {
        sub_service_name: 'Image Analysis:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Utilizing advanced software like IMAGE J for:',
            sub_category_description: '',
            super_sub_category: [
              {
                super_sub_category_name: `Precise measurements`
              },
              {
                super_sub_category_name: `Detailed observations`
              },
              {
                super_sub_category_name: `Quantitative analysis`
              },
            ]
          },
          {
            sub_category_name: 'Evaluation of biomarkers, including vascular density in oncology.',
          },
        ]
      },
      {
        sub_service_name: 'Sample Collection and Consultation',
      },
    ]
  },
  'microbiology': {
    service_name: 'Microbiology',
    service_desecripiton: 'Microbiology is the study of microorganisms, including bacteria, viruses, fungi, and protozoa. This field is fundamental to understanding the roles these microorganisms play in health, disease, and the environment. Microbiologists investigate how these tiny organisms interact with humans, animals, plants, and the environment, leading to discoveries that improve healthcare, agriculture, and environmental management.',
    services_offered: [
      {
        sub_service_name: 'Antimicrobial Activity Assessment',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Disc Diffusion Method',
          },
          {
            sub_category_name: 'Agar Well Diffusion Method',
          }
        ]
      },
      {
        sub_service_name: 'Antibiotic Activity Testing:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Minimum Inhibitory Concentration (MIC)',
          },
          {
            sub_category_name: 'Minimum Bactericidal Concentration (MBC)',
          },
          {
            sub_category_name: 'Minimum Fungicidal Concentration (MFC)',
          }
        ]
      },
      {
        sub_service_name: 'Antagonistic Activity Assessments:',
        sub_service_description: 'Exploration of microbial interactions.',
      },
      {
        sub_service_name: 'Plastic Degradation Studies:',
        sub_service_description: 'Analysis of microorganisms that degrade plastics.',
      },
      {
        sub_service_name: 'Environmental Sample Analysis:',
        sub_service_description: 'Degradation studies and monitoring of pollutants.',
      },
      {
        sub_service_name: 'Biofilm Assay:',
        sub_service_description: 'Examination of biofilm formation.',
      },
      {
        sub_service_name: 'Water Quality Testing:',
        sub_service_description: 'Identification of E. coli and coliforms in water samples.',
      },
      {
        sub_service_name: 'Customized Prebiotic and Probiotic Studies:',
        sub_service_description: 'Tailored studies on prebiotics and probiotics.',
      },
      {
        sub_service_name: 'Mucoid Colony Identification:',
        sub_service_description: 'Identification using different stains.',
      },
      {
        sub_service_name: 'Biochemical Tests:',
        sub_service_description: 'Complete biochemical tests can be done to identify the organism',
      },
      {
        sub_service_name: 'Colony Forming Unit (CFU) Calculation:',
        sub_service_description: 'Quantification of microbial populations.',
      },
      {
        sub_service_name: 'Molecular Identification:',
        sub_service_description: 'Genetic level identification of bacteria and fungi.',
      },
      {
        sub_service_name: 'Drug Resistance, Multi-Drug Resistance and Gene Identification:',
        sub_service_description: 'Analysis of drug resistance and associated genes.',
      },
      {
        sub_service_name: 'Siderophore Activity:',
        sub_service_description: 'Assessment of siderophore production.',
      },
      {
        sub_service_name: 'Pathogenic Organism Identification:',
        sub_service_description: 'Identification through biochemical and molecular approaches (on request).',
      },
    ]
  },
  'nanotechnology': {
    service_name: 'Nanotechnology',
    service_desecripiton: 'Nanotechnology is a cutting edge field that involves the manipulation and application of materials at the nanoscale, offering revolutionary advancements across various industries, including medicine, and environmental science. At ADRC, we provide comprehensive nanotechnology services that include the synthesis and characterization of nano particles, ensuring precise and high quality outcomes for research and development.',
    services_offered: [
      {
        sub_service_name: 'Nanoparticle Synthesis',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Silver (Ag) Nanoparticles',
          },
          {
            sub_category_name: 'Gold (Au) Nanoparticles',
          },
          {
            sub_category_name: 'Copper (Cu) Nanoparticles',
          },
          {
            sub_category_name: 'Titanium Dioxide (TiO2) Nanoparticles',
          },
          {
            sub_category_name: 'Zinc Oxide (ZnO) Nanoparticles',
          },
          {
            sub_category_name: 'Selenium (Se) Nanoparticles',
          }
        ]
      },
      {
        sub_service_name: 'Nanoparticle Characterization',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'UV Visible Spectroscopy (UV):',
            sub_category_description: 'Analysis of optical properties and confirmation of nanoparticle synthesis.'
          },
          {
            sub_category_name: 'Fourier Transform Infrared Spectroscopy (FTIR):',
            sub_category_description: 'Identification of functional groups and chemical bonding.'
          },
          {
            sub_category_name: 'Scanning Electron Microscopy (SEM):',
            sub_category_description: 'Highresolution imaging of nanoparticle morphology.'
          },
          {
            sub_category_name: 'Energy Dispersive Xray Analysis (EDAX):',
            sub_category_description: 'Elemental composition analysis.'
          },
          {
            sub_category_name: 'Transmission Electron Microscopy (TEM):',
            sub_category_description: 'Detailed internal structure and size distribution of nanoparticles.'
          },
          {
            sub_category_name: 'XRay Diffraction (XRD):',
            sub_category_description: 'Crystallographic structure determination.'
          },
          {
            sub_category_name: 'Dynamic Light Scattering (DLS):',
            sub_category_description: 'Particle size distribution analysis.'
          },
        ]
      },
    ]
  },
  'phytochemistry': {
    service_name: 'Phytochemistry',
    service_desecripiton: 'Phytochemistry is the study of the chemicals derived from plants, which play a crucial role in drug discovery, nutrition, and understanding plant biology. At ADRC, we offer comprehensive phytochemistry services to support research and development in these areas. Our stateoftheart laboratory is equipped with modern technology to provide precise analysis and comprehensive profiling of plant derived compounds.',
    services_offered: [
      {
        sub_service_name: 'Phytochemical Screening:',
        sub_service_description: 'Analysis and identification of various plant secondary metabolites, including:',
        subcategory: [
          {
            sub_category_name: 'Flavonoids',
          },
          {
            sub_category_name: 'Phenols',
          },
          {
            sub_category_name: 'Alkaloids',
          },
          {
            sub_category_name: 'Tannins',
          },
          {
            sub_category_name: 'Steroids',
          },
          {
            sub_category_name: 'Proteins',
          },
          {
            sub_category_name: 'Carbohydrates',
          },
          {
            sub_category_name: 'Glycosides',
          },
          {
            sub_category_name: 'Terpenoids',
          }
        ]
      },
      {
        sub_service_name: 'Colorimetric Estimation:',
        sub_service_description: 'Quantitative analysis of key phytochemicals using colorimetric methods, including:',
        subcategory: [
          {
            sub_category_name: 'Flavonoids',
          },
          {
            sub_category_name: 'Phenols',
          },
          {
            sub_category_name: 'Alkaloids',
          },
          {
            sub_category_name: 'Tannins',
          },
          {
            sub_category_name: 'Steroids',
          },
          {
            sub_category_name: 'Proteins',
          },
          {
            sub_category_name: 'Carbohydrates',
          }
        ]
      },
      {
        sub_service_name: 'Chromatography Separation',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Thin Layer Chromatography (TLC)',
          },
          {
            sub_category_name: 'Gas Chromatography Mass Spectrometry (GCMS)',
          },
          {
            sub_category_name: 'High Performance Liquid Chromatography (HPLC)',
          },
          {
            sub_category_name: 'Liquid Chromatography Mass Spectrometry (LCMS)',
          },
          {
            sub_category_name: 'Column Chromatography',
          }
        ]
      },
      {
        sub_service_name: 'Complete Plant Biochemical Test:',
        sub_service_description: 'Comprehensive biochemical profiling of plant samples to understand their nutritional and medicinal properties.',
      },
      {
        sub_service_name: 'Plant Biology in Phytochemistry',
        sub_service_description: 'Analysis of key plant pigments and their biochemical roles, including:',
        subcategory: [
          {
            sub_category_name: 'Chlorophylls',
          },
          {
            sub_category_name: 'Anthocyanins',
          },
          {
            sub_category_name: 'Carotenoids',
          }
        ]
      },
    ]
  },
  'environmental-analysis': {
    service_name: 'Environmental Analysis',
    service_desecripiton: 'At Ashwanth Diagnostic and Research Centre (ADRC), we offer comprehensive environmental analysis services designed to assess and ensure the quality of water, soil, herbal products, dairy products, and more. Utilizing advanced technology and adhering to stringent quality standards, our services provide accurate and reliable data critical for environmental monitoring and health assessments.',
    services_offered: [
      {
        sub_service_name: 'Water Sample Analysis:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Appearance:',
            sub_category_description: 'Visual inspection of water clarity and color.'
          },
          {
            sub_category_name: 'pH:',
            sub_category_description: 'Measurement of acidity or alkalinity.'
          },
          {
            sub_category_name: 'Turbidity:',
            sub_category_description: 'Assessment of water clarity by measuring the level of suspended particles.'
          },
          {
            sub_category_name: 'Total Dissolved Solids (TDS):',
            sub_category_description: 'Quantification of dissolved substances in water.'
          },
          {
            sub_category_name: 'Total Hardness as CaCO3:',
            sub_category_description: 'Determination of water hardness, indicating calcium and magnesium content.'
          },
          {
            sub_category_name: 'Total Alkalinity as CaCO3:',
            sub_category_description: 'Measurement of water’s buffering capacity.'
          },
          {
            sub_category_name: 'Ammonia:',
            sub_category_description: 'Detection of ammonia levels.'
          },
          {
            sub_category_name: 'Calcium and Magnesium:',
            sub_category_description: 'Quantification of calcium and magnesium ions.'
          },
        ]
      },
      {
        sub_service_name: 'Soil Sample Analysis:',
        sub_service_description: 'Comprehensive evaluation of soil composition and nutrient content to support agricultural and environmental management.',
      },
      {
        sub_service_name: 'Herbal Testing:',
        sub_service_description: 'Nutritional and chemical analysis of herbal products, including:',
        subcategory: [
          {
            sub_category_name: 'Energy',
          },
          {
            sub_category_name: 'Total Fat',
          },
          {
            sub_category_name: 'Saturated Fat',
          },
          {
            sub_category_name: 'Trans Fat',
          },
          {
            sub_category_name: 'Carbohydrates',
          },
          {
            sub_category_name: 'Dietary Fiber',
          },
          {
            sub_category_name: 'Sugar',
          },
          {
            sub_category_name: 'Protein',
          },
          {
            sub_category_name: 'Cholesterol',
          },
          {
            sub_category_name: 'Sodium',
          },
          {
            sub_category_name: 'Minerals: ',
            sub_category_description: 'Calcium, Iron, Magnesium, Potassium, Zinc'
          },
          {
            sub_category_name: 'Omega 3',
          },
          {
            sub_category_name: 'Vitamins:',
            sub_category_description: 'Vitamin A, B1, B2, B3, B5, B6, B9, C, D, E, K'
          },
        ]
      },
      {
        sub_service_name: 'Dairy Product Testing:',
        sub_service_description: 'Analysis of dairy products for nutritional content, quality, and safety.',
      },
      {
        sub_service_name: 'Pesticides and Heavy Metal Analysis:',
        sub_service_description: 'Detection and quantification of pesticide residues and heavy metals in various samples to ensure compliance with safety standards.',
      },
      {
        sub_service_name: 'Water Samples:',
        sub_service_description: 'Analysis of different types of water samples including:',
        subcategory: [
          {
            sub_category_name: 'Drinking Water:',
            sub_category_description: 'Quality and safety assessment.'
          },
          {
            sub_category_name: 'Sewage Water:',
            sub_category_description: 'Evaluation of contaminants and treatment effectiveness.'
          },
          {
            sub_category_name: 'Treated Water:',
            sub_category_description: 'Assessment of water posttreatment for reuse or discharge.'
          },
        ]
      },
    ]
  },
  'proteomics': {
    service_name: 'Proteomics',
    service_desecripiton: 'Proteomics is the study of the entire set of proteins produced by an organism or system, providing valuable insights into cellular functions, disease mechanisms, and drug discovery. At ADRC, we offer a range of advanced proteomics services utilizing cutting-edge technologies and methodologies. Our services are tailored to meet the diverse needs of researchers, clinicians, and pharmaceutical industries.',
    services_offered: [
      {
        sub_service_name: 'Protein Estimation:',
        sub_service_description: 'Utilizing the BRADFORD method for accurate quantification of protein concentrations.',
      },
      {
        sub_service_name: 'SDS-PAGE (Sodium Dodecyl Sulfate Polyacrylamide Gel Electrophoresis):',
        sub_service_description: 'Separation of proteins based on their molecular weight under denaturing conditions.',
      },
      {
        sub_service_name: 'Native PAGE (Native Polyacrylamide Gel Electrophoresis):',
        sub_service_description: 'Separation of proteins under native conditions to preserve their native structure and function.',
      },
      {
        sub_service_name: 'MALDI-TOF (Matrix-Assisted Laser Desorption/Ionization Time-of-Flight):',
        sub_service_description: 'High-resolution mass spectrometry technique for protein identification and analysis.',
      },
      {
        sub_service_name: '2D Gel Electrophoresis:',
        sub_service_description: 'Comprehensive separation of proteins based on both molecular weight and isoelectric point, allowing for precise characterization and comparison of protein profiles.',
      },
      {
        sub_service_name: 'LC-MS (Liquid Chromatography-Mass Spectrometry):',
        sub_service_description: 'Highly sensitive and accurate technique for protein identification, quantification, and characterization.',
      },
      {
        sub_service_name: 'Protein-Protein Interaction Studies:',
        sub_service_description: 'Investigation of interactions between proteins to elucidate cellular pathways, molecular mechanisms, and disease processes.',
      }
    ]
  },
  'research-development': {
    service_name: 'Research & Development',
    service_desecripiton: 'At ADRC, our Research and Development (R&D) division is dedicated to advancing scientific knowledge and developing innovative solutions in various fields of biomedical research. We employ state-of-the-art laboratory models and techniques to explore key areas of scientific inquiry, adhering to rigorous bioethical standards and Good Laboratory Practices (GLP).',
    services_offered: [
      {
        sub_service_name: 'Laboratory Working Models',
        subcategory: [
          {
            sub_category_name: 'Drosophila melanogaster (Fruit Fly)',
          },
          {
            sub_category_name: 'Bombyx mori (Silkworm)',
          },
          {
            sub_category_name: 'Mouse Models',
          },
          {
            sub_category_name: 'In-vitro and Primary Cancer Cell Lines',
          },
        ]
      },
      {
        sub_service_name: 'Vesicles Mediated Cellular Communications',
      },
      {
        sub_service_name: 'Tumor-Host Interactions',
        subcategory: [
          {
            sub_category_name: 'Tumor metastasis',
          },
          {
            sub_category_name: 'Circulating cancer stem cells physiological functions and its differentiation',
          },
        ]
      },
      {
        sub_service_name: 'Vector Control Studies Using Biological Agents',
      },
    ]
  },
  'waste-management': {
    service_name: 'Waste Management',
    service_desecripiton: 'At ADRC, we are dedicated to environmental sustainability and follow rigorous waste management protocols to minimize our environmental footprint and ensure safety.',
    services_offered: [
      {
        sub_service_name: 'Segregation of Waste',
        subcategory: [
          {
            sub_category_name: 'Biomedical Waste',
          },
          {
            sub_category_name: 'Chemical Waste',
          },
          {
            sub_category_name: 'Recyclable Materials',
          },
        ]
      },
      {
        sub_service_name: 'Safe Disposal Methods',
        subcategory: [
          {
            sub_category_name: 'Autoclaving',
          },
          {
            sub_category_name: 'Incineration',
          },
          {
            sub_category_name: 'Chemical Neutralization',
          },
        ]
      },
      {
        sub_service_name: 'Minimizing Waste Generation',
        subcategory: [
          {
            sub_category_name: 'Strategies to reduce waste generation',
          },
        ]
      },
      {
        sub_service_name: 'Training and Awareness',
        subcategory: [
          {
            sub_category_name: 'Regular staff training',
          },
          {
            sub_category_name: 'Promoting awareness of waste management',
          },
        ]
      },
    ]
  },
  'genomics': {
    service_name: 'Genomics',
    service_desecripiton: 'Genomics is a field of science that focuses on the study of genomes, encompassing the complete set of DNA within an organism. At ADRC, we offer a comprehensive range of genomics services, employing cutting-edge technologies and methodologies to address various research needs in genetics and molecular biology.',
    services_offered: [
      {
        sub_service_name: 'Customized Primer Designing:',
        sub_service_description: 'Design of specific primers tailored to target genes or regions of interest for PCR amplification.',
      },
      {
        sub_service_name: 'Target Gene Amplification:',
        sub_service_description: 'PCR amplification of target genes for various applications such as genotyping, gene expression analysis, mutation detection, customized cloning and gene silencing.',
      },
      // {
      //   sub_service_name: '18S Identification:',
      //   sub_service_description: 'Identification and characterization of the 18S ribosomal RNA gene, commonly used in phylogenetic studies and species identification.',
      // },
      {
        sub_service_name: 'Molecular Fingerprinting Identifications:',
        sub_service_description: 'Utilization of various molecular marker techniques for genetic fingerprinting and diversity analysis, including:',
        subcategory: [
          {
            sub_category_name: 'Restriction Fragment Length Polymorphism (RFLP)',
          },
          {
            sub_category_name: 'Random Amplified Polymorphic DNA (RAPD)',
          },
          {
            sub_category_name: 'Amplified Fragment Length Polymorphism (AFLP)',
          },
        ]
      },
      {
        sub_service_name: 'Primer-Based Techniques for Species Identification',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Cytochrome c oxidase (COX)',
          },
          {
            sub_category_name: 'Cytochrome b (Cyt-b)',
          },
          {
            sub_category_name: 'Inter-Simple Sequence Repeat (ISSR) markers',
          },
          {
            sub_category_name: 'trnL-F',
          },
          {
            sub_category_name: 'trnH',
          },
          {
            sub_category_name: 'Internal Transcribed Spacer 2 (ITS2)',
          },
          {
            sub_category_name: 'Maturase K (MatK)',
          },
          {
            sub_category_name: 'Ribulose-bisphosphate carboxylase (rbcL)',
          },
          {
            sub_category_name: '18S rRNA',
          },
          {
            sub_category_name: '16S rRNA',
          }
        ]
      },
      {
        sub_service_name: 'DNA Sequencing:',
        sub_service_description: 'DNA sequencing determines the exact order of nucleotide bases—adenine(A), guanine(G), cytosine(C), and thymine(T) — in a DNA molecule. This process provides critical insights into genetic variations and is essential for research, diagnostics, and personalized medicine.',
      },
      {
        sub_service_name: 'RNA Sequencing:',
        sub_service_description: 'RNA sequencing (RNA-Seq) involves high-throughput sequencing of RNA molecules to analyze the transcriptome and profile gene expression. This technique studies all RNA molecules produced in a cell or tissue.',
      },
      {
        sub_service_name: 'Transcriptomics:',
        sub_service_description: 'Study of the transcriptome, including all RNA molecules produced in a cell or tissue, to understand gene expression patterns and regulatory mechanisms.',
      },
      {
        sub_service_name: 'Cloning:',
        sub_service_description: 'Comprehensive cloning services including:',
        subcategory: [
          {
            sub_category_name: 'Sequencing of cloned DNA fragments for validation and characterization.',
          },
          {
            sub_category_name: 'Overexpression studies to investigate gene function and protein production.',
          },
          {
            sub_category_name: 'Gene knockout experiments for functional analysis and disease modeling.',
          },
          {
            sub_category_name: 'mCherry Expression',
          },
          {
            sub_category_name: 'GUS Expression',
          },
        ]
      }
    ]
  },
  'dental-medical': {
    service_name: 'Dental and Medical Microbiology',
    service_desecripiton: 'Dental and medical microbiology plays a crucial role in understanding the microbial factors contributing to various diseases and conditions, including urinary tract infections (UTIs), diabetes, obesity, and dental diseases. At Ashwanth Diagnostic and Research Centre (ADRC), we offer specialized services in dental and medical microbiology, utilizing advanced techniques to study microbial pathogens and their interactions with the host.',
    services_offered: [
      {
        sub_service_name: 'Dental Sample Sectioning and Staining',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Precision sectioning of dental samples to prepare them for microscopic examination.',
          },
          {
            sub_category_name: 'Staining of dental samples with specific stains such as Sirius Red and Hematoxylin and Eosin (H&E) for visualization and characterization of tissue structures.',
          },
        ]
      },
      {
        sub_service_name: 'UTI, Diabetic & Obesity Related Gene Studies',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: 'Investigation of genetic factors associated with urinary tract infections (UTIs), diabetes, and obesity to understand susceptibility and disease mechanisms.',
          },
          {
            sub_category_name: 'Utilization of advanced molecular biology techniques for gene expression analysis and genetic profiling.',
          },
        ]
      }
    ]
  },
  'biomedical-animal-studies': {
    service_name: 'Biomedical Functional Analysis & Animal Studies',
    service_desecripiton: 'Biomedical functional analysis and animal studies play a critical role in understanding the therapeutic potential and safety profiles of various compounds and interventions. At Ashwanth Diagnostic and Research Centre (ADRC), we offer a wide range of studies to assess the functional activities of biomedical agents using both in vivo and in vitro models. Our dedicated team of researchers and veterinarians ensures ethical conduct and robust experimental design for accurate and reliable results.',
    services_offered: [
      {
        sub_service_name: 'Anticancer Activity:',
        sub_service_description: 'Evaluation of compounds or treatments for their ability to inhibit cancer cell growth or induce apoptosis using cancer cell lines or animal tumor models.',
      },
      {
        sub_service_name: 'Antidiabetic Activity:',
        sub_service_description: 'Assessment of compounds or interventions for their potential to regulate blood glucose levels and improve insulin sensitivity in animal models of diabetes.',
      },
      {
        sub_service_name: 'Anti-inflammatory Activity:',
        sub_service_description: 'Investigation of the ability of compounds to reduce inflammation and associated symptoms in animal models of acute or chronic inflammation.',
      },
      {
        sub_service_name: 'Antidiuretic Activity:',
        sub_service_description: 'Evaluation of compounds for their ability to reduce urine output and increase water reabsorption in animal models of diuresis.',
      },
      {
        sub_service_name: 'Antipyretic Activity:',
        sub_service_description: 'Assessment of compounds for their ability to reduce fever and lower body temperature in animal models of fever induction.',
      },
      {
        sub_service_name: 'Larvicidal Activity:',
        sub_service_description: 'Study of compounds or natural products for their ability to kill or inhibit the growth of larvae, such as Bombyx mori (silkworm), which serves as a model organism for larvicidal studies.',
      },
      {
        sub_service_name: 'Anthelmintic Activity:',
        sub_service_description: 'Evaluation of compounds for their ability to kill or expel parasitic worms in animal models of helminth infections.',
      },
      {
        sub_service_name: 'Wound Healing Activity:',
        sub_service_description: 'Assessment of compounds or interventions for their ability to promote wound closure, tissue regeneration, and inflammation resolution in animal models of wound healing.',
      },
    ]
  },
  'bioinformatics': {
    service_name: 'Bioinformatics',
    service_desecripiton: 'Bioinformatics plays a vital role in modern biological and medical research, utilizing computational methods to analyze large-scale biological data and uncover meaningful insights. At Ashwanth Diagnostic and Research Centre (ADRC), we offer a range of bioinformatics services to support researchers in their quest for understanding complex biological systems and phenomena.',
    services_offered: [
      {
        sub_service_name: 'Protein-Protein Interaction Analysis',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Prediction and analysis of protein-protein interactions using computational methods and databases.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Identification of potential binding partners and functional complexes to elucidate cellular pathways and disease mechanisms.'
          },
        ]
      },
      {
        sub_service_name: 'Molecular Docking:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Computational modeling of protein-ligand interactions to predict binding affinities and modes of interaction.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Virtual screening of small molecule libraries to identify potential drug candidates or lead compounds for further experimental validation.'
          },
        ]
      },
      {
        sub_service_name: 'Phylogenetic Tree Construction:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Reconstruction of evolutionary relationships among species or genes based on sequence data.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Phylogenetic analysis using various algorithms and methods to infer evolutionary histories and genetic divergence.'
          },
        ]
      },
      {
        sub_service_name: 'Structure Prediction and Other Bioinformatics Studies:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Prediction of protein structures using homology modeling, ab initio modeling, and other computational methods.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Analysis of sequence-structure-function relationships to understand the biological significance of genetic variations and mutations.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Functional annotation of genes and proteins, including gene ontology analysis, pathway enrichment analysis, and functional classification.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Transcriptomic and genomic data analysis, including differential gene expression analysis, pathway analysis, and variant calling.'
          },
        ]
      },
    ]
  },
  'clinical-diagnosis': {
    service_name: 'Clinical Diagnosis',
    service_desecripiton: 'Clinical diagnosis is essential for identifying and managing various medical conditions, providing crucial information for patient care and treatment decisions. At Ashwanth Diagnostic and Research Centre (ADRC), we offer a comprehensive range of clinical diagnostic services, utilizing advanced laboratory techniques and state-of-the-art equipment to deliver accurate and timely results.',
    services_offered: [
      {
        sub_service_name: 'Hematology:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Analysis of blood samples to assess the cellular components, including red blood cells, white blood cells, and platelets.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include complete blood count (CBC), hemoglobin analysis, hematocrit measurement, and blood smear examination.'
          },
        ]
      },
      {
        sub_service_name: 'Biochemistry:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Evaluation of biochemical markers in blood and body fluids to assess organ function, metabolic status, and disease processes.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include Renal function tests, kidney function tests (KFTs), lipid profile, glucose levels, electrolyte analysis, and more.'
          },
        ]
      },
      {
        sub_service_name: 'Serology:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Detection of specific antibodies, antigens, or infectious agents in serum or other body fluids to diagnose infectious diseases, autoimmune disorders, and immune responses.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include ELISA (enzyme-linked immunosorbent assay), Western blotting, and rapid diagnostic tests (RDTs).'
          },
        ]
      },
      {
        sub_service_name: 'Microbiology:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Identification and characterization of microbial pathogens in clinical samples to diagnose infectious diseases.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include culture and sensitivity testing, Gram staining, acid-fast staining, and molecular diagnostics (PCR).'
          },
        ]
      },
      {
        sub_service_name: 'Fluid Analysis:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Examination of various body fluids, including urine, cerebrospinal fluid (CSF), pleural fluid, and ascitic fluid, to diagnose and monitor medical conditions.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include Urine analysis, CSF analysis, fluid cell count, protein and glucose measurement, and fluid culture.'
          },
        ]
      },
      {
        sub_service_name: 'Hormone Testing:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Measurement of hormone levels in blood or other body fluids to assess endocrine function, diagnose hormonal disorders, and monitor hormone therapy.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tests include thyroid function tests (TFTs), reproductive hormone assays, adrenal function tests, and more.'
          },
        ]
      },
    ]
  },
  'scientific-writing': {
    service_name: 'Scientific Writing & Patent Filing',
    service_desecripiton: 'Scientific writing is a crucial aspect of academic and research endeavors, encompassing various formats and styles tailored to communicate scientific findings effectively. At Ashwanth Diagnostic and Research Centre (ADRC), we offer a range of scientific writing services to support researchers, academicians, and students in their scholarly pursuits.',
    services_offered: [
      {
        sub_service_name: 'Research Proposals:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Preparation of comprehensive research proposals outlining the objectives, methodology, significance, and expected outcomes of proposed research projects.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Tailored proposals for funding applications, grant submissions, and institutional approvals.'
          },
        ]
      },
      {
        sub_service_name: 'Paper Writing:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Assistance in writing research papers, review articles, and scientific manuscripts for publication in peer-reviewed journals.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Support throughout the writing process, from drafting and editing to final submission and revisions.'
          },
        ]
      },
      {
        sub_service_name: 'Thesis Writing:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: `Guidance and support for writing doctoral (Ph.D.) and master's (M.Sc./M.Tech.) theses, including formatting, structure, literature review, methodology, results interpretation, and discussion.`
          },
          {
            sub_category_name: '',
            sub_category_description: 'Comprehensive editing and proofreading services to ensure clarity, coherence, and adherence to academic standards.'
          },
        ]
      },
      {
        sub_service_name: 'Assistance in Ph.D. Workflow Chart:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Development of workflow charts and timelines to plan and organize various stages of the Ph.D. research project, including literature review, experimental design, data collection, analysis, and thesis writing.'
          }
        ]
      },
      {
        sub_service_name: 'Assistance for Ph.D. Program (Part/Full Time):',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Support and guidance for Ph.D. students at various stages of their doctoral studies, including topic selection, literature review, research methodology, data analysis, and thesis preparation.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Assistance for both part-time and full-time Ph.D. students to navigate academic requirements, deadlines, and milestones.'
          },
        ]
      },
      {
        sub_service_name: 'Plagiarism Checking:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Utilization of plagiarism detection software to ensure the originality and integrity of research manuscripts, theses, and other scholarly works.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Detailed reports and recommendations for addressing any instances of plagiarism or improper citation.'
          },
        ]
      },
      {
        sub_service_name: 'Patent Filing:',
        sub_service_description: '',
        subcategory: [
          {
            sub_category_name: '',
            sub_category_description: 'Assistance with patent filing processes, including preparation and submission of patent applications.'
          },
          {
            sub_category_name: '',
            sub_category_description: 'Support in drafting patent claims, conducting prior art searches, and navigating intellectual property laws and regulations.'
          },
        ]
      },
    ]
  },
  'training-internship': {
    service_name: 'Internships & Workshops',
    service_desecripiton: 'Internships and workshops play a vital role in providing hands-on training and practical experience to students and professionals in various field in Lifesciences. At Ashwanth Diagnostic and Research Centre (ADRC), we offer a range of internships and workshops designed to impart essential skills and knowledge in molecular biology, proteomics, microbiology, phytochemistry, nanotechnology, cloning, and bioinformatics.',
    services_offered: [
      {
        sub_service_name: 'Basic Molecular Techniques:',
        sub_service_description: 'Hands-on training in fundamental molecular biology techniques, including DNA extraction, PCR, gel electrophoresis, and DNA sequencing.',
      },
      {
        sub_service_name: 'Proteomics Techniques:',
        sub_service_description: 'Practical experience in protein estimation, separation techniques such as SDS-PAGE  and protein sequencing methods.',
      },
      {
        sub_service_name: 'Molecular Microbiology Techniques:',
        sub_service_description: 'Training in molecular methods for microbial identification, gene amplification, and characterization, including PCR, DNA sequencing, and gene expression analysis.',
      },
      {
        sub_service_name: 'Phytochemistry & Chromatographic Techniques:',
        sub_service_description: 'Laboratory sessions covering phytochemical screening, extraction techniques, and chromatographic methods such as HPLC and GC-MS for compound analysis.',
      },
      {
        sub_service_name: 'Nanoparticle Synthesis & Functional Analysis:',
        sub_service_description: 'Hands-on experience in synthesizing nanoparticles and characterizing their properties using techniques like UV-Vis spectroscopy, TEM, and DLS.',
      },
      {
        sub_service_name: 'Basics of Cloning:',
        sub_service_description: 'Introduction to the principles and techniques of cloning, including plasmid DNA isolation, restriction enzyme digestion, ligation, and transformation.',
      },
      {
        sub_service_name: 'TA Cloning, Overexpression (Non-binary & Binary):',
        sub_service_description: 'Training in TA cloning techniques for cloning PCR products into plasmid vectors, as well as overexpression systems in both non-binary and binary systems.',
      },
      {
        sub_service_name: 'Basic Bioinformatics Techniques:',
        sub_service_description: 'Introduction to bioinformatics tools and databases for sequence analysis, molecular modeling, and data interpretation.',
      },
    ]
  }
}

export default ServicesList;